import Details from './components/Details';
import Legend from './components/Legend';
import ReportForm from './components/ReportForm';
import './index.css';
import Map from './Map';
import { Modal } from './components/ModalHeadless';

function App() {

  return (
    <div>
      <section className='head-container'>
        <section className='legend-element'>
          <Legend />
        </section>
        <section className='report-element'>
          <ReportForm/>
        </section>
      </section>
      <section className='map-element'>
        <Map/>
      </section>
      <section className='details-element'>
        <Details/>
      </section>
      <Modal/>
    </div>
  );
}

export default App;
